export default __webpack_public_path__ + "static/media/13.04b1b347.svg";